import React from 'react';

import SchemaEditor from '../../components/Rbac/SchemaEditor/SchemaEditor';

function SchemaEditorView() {
  return <SchemaEditor />;
}

export default SchemaEditorView;
